import React, { useState, useEffect } from 'react';
import ufood from '../../../common/images/ufood-logo.svg';
import { MOBILE, listStatusDriverExist } from '../../../utils/constants';
import { formatLocalPhoneNumber, formatPhoneNumberWa, isEmptyData, formatPhoneNumber } from '../../../utils/helper';
import { LiveTrackingIcon } from '../../../utils/svg';
import { ExclamationCircleIcon } from '@heroicons/react/24/solid';
import { useSelector } from 'react-redux';
import Modal from '../../Modal';
import { useLocation } from 'react-router-dom';
import useNavigation from '../../../hook/useNavigation';

function Tracking({ orderDetails }) {
	const navigate = useNavigation();
  const location = useLocation();
	const currentPath = location.pathname;
  const user = useSelector((store) => store?.user)
  const isMobile = user?.device === MOBILE

  const [popup, setPopup] = useState({
    show: false,
    confirm: false,
    type: null,
    value: null,
  });

  const status = orderDetails?.delivery_order_details ? orderDetails.delivery_order_details?.status : null;
  const foundDriver = listStatusDriverExist.includes(status);
  const driverName = orderDetails?.delivery_order_details?.track?.courier?.name ?? orderDetails?.delivery_courier_name ?? '';
  const driverPhone = orderDetails?.delivery_order_details?.track?.courier?.phone ?? orderDetails?.delivery_courier_phone ?? '';
  const trackingUrl =
  orderDetails?.delivery_order_details?.trackingUrl != null &&
  orderDetails?.delivery_order_details?.trackingUrl !== ''
    ? orderDetails?.delivery_order_details?.trackingUrl
    : orderDetails?.delivery_tracking_url ?? '';

  const handlePopup = (type, value) => {
    setPopup(((prev) => {
      return {
        ...prev,
        show: true,
        type,
        value
      }
    }))
  }

  const handleCall = (phone = "") => {
    const driverPhone = formatPhoneNumber(phone);
    if (driverPhone) {
      const formated = `tel:${driverPhone}`;
      window.location.href = formated;
    }
  };

  const handleChat = (phone = "") => {
    const driverPhone = formatPhoneNumberWa(phone);
		if (driverPhone && user?.is_b2b) {
      // bca new tab
      window.open(`https://wa.me/${driverPhone}`, '_blank');
		} else {
			const formated = `https://wa.me/${driverPhone}`;
			window.location.href = formated;
		}
  };

  const handleTracking = (link = "") => {
    // window.location.href = link;
    // bca new tab
    if (link && user?.is_b2b && user?.companyName?.toLowerCase() !== 'bri') {
      window.open(link, '_blank');
    } else {
      return navigate.push({
        pathname: '/tracking',
        state: {
          trackingUrl: link.replace(/^http:\/\//i, 'https://') || '',
          backPath: currentPath ?? '/',
        },
      });
    }
  };

  useEffect(() => {
    if (popup?.confirm && !popup?.show && popup?.type === "call") {
      handleCall(popup?.value)
    }
    if (popup?.confirm && !popup?.show && popup?.type === "wa") {
      handleChat(popup?.value)
    }
    if (popup?.confirm && !popup?.show && popup?.type === "tracking") {
      handleTracking(popup?.value)
    }
    if (popup.confirm && !popup?.show) {
      setPopup({
        show: false,
        confirm: false,
        type: null,
        value: null,
      });
    }
  }, [popup])

	return (
		<div>
			<h2 className='text-sm font-semibold'>Lacak Pesanan Anda</h2>
			<div
				className='w-full p-4'
				style={{
					marginTop: '8px',
					marginBottom: '10px',
					border: '1px solid #D3D3D3',
					borderRadius: '8px',
				}}>
				<div className='flex items-center justify-between'>
					<img src={ufood} alt='Ufood' />
					{trackingUrl && (
						<div
              id='detail_order_live_tracking'
							className='text-xs font-normal text-[var(--blue-chaos)]'
							onClick={() => {
                if (user?.is_b2b && user?.companyName?.toLowerCase() !== 'bri') {
                  return handlePopup("tracking", trackingUrl)
                }
                return handleTracking(trackingUrl)
              }}>
							Lacak secara Real-Time
						</div>
					)}
				</div>
				<div className='flex mt-4 gap-2'>
          <LiveTrackingIcon className='h-auto min-w-24 w-24 object-cover object-center fill-[var(--rose-violet)]' />
					<div className='flex flex-col'>
						<p className='font-semibold mr-1 text-[var(--dark-gray)]'>
              {orderDetails?.orderStatus === "1"
                ? "Menunggu Konfirmasi dari Outlet"
                : !foundDriver || isEmptyData(driverName) || isEmptyData(driverPhone)
                ? `Sedang Mencari Driver`
                : driverName}
						</p>
            <p className={`${(!foundDriver || isEmptyData(driverName) || isEmptyData(driverPhone) || isMobile) && 'hidden'} font-semibold mr-1 text-[var(--dark-gray)]`}>
              {formatLocalPhoneNumber(driverPhone)}
						</p>
						<p className='text-xs text-gray-500 pt-1'>
              {orderDetails?.orderStatus === "1"
                  ? "Mohon ditunggu"
                  : !foundDriver || isEmptyData(driverName) || isEmptyData(driverPhone)
                  ? "Mohon ditunggu, kami sedang mencarikan driver"
                  : orderDetails?.store?.[0]?.name}
            </p>
						{foundDriver && !isEmptyData(driverName) && !isEmptyData(driverPhone) && (
							<div className='flex justify-start gap-2 pt-1'>
								<button
                  id='detail_order_call_driver'
									className={`${(!foundDriver || !isMobile) && 'hidden'} text-[var(--rose-violet)] border border-solid border-[var(--rose-violet)] h-10 w-16 font-medium text-sm`}
									onClick={() => {
                    if (user?.is_b2b) {
                      return handlePopup("call", driverPhone)
                    }
                    return handleCall(driverPhone)
                  }}>
									Call
								</button>
								<button
                  id='detail_order_chat_driver'
									className={`${!foundDriver && 'hidden'} bg-[var(--rose-violet)] text-white h-10 w-16 font-medium border-solid border-[var(--rose-violet)] text-sm`}
									onClick={() => {
                    if (user?.is_b2b) {
                      return handlePopup("wa", driverPhone)
                    }
                    return handleChat(driverPhone)
                  }}>
									Chat
								</button>
							</div>
						)}
					</div>
				</div>
			</div>
      {popup?.show && (
        <Modal isOpen={popup?.show} onClose={() => {
          setPopup({
            show: false,
            confirm: false,
            type: null,
            value: null,
          });
        }}>
          <div className={`bg-white p-4 rounded-xl shadow-custom transition-transform duration-1000 ease-in-out ${popup?.show ? 'translate-y-0 relative' : 'translate-y-full hidden'}`}>
            <div className='flex justify-center'>
              <div className='bg-gray-300 h-1.5 w-10 rounded-full' />
            </div>
            <div className='items-center flex justify-center mt-8'>
              <ExclamationCircleIcon className="h-14 w-auto fill-[var(--rose-violet)]" />
            </div>
            <div className='my-5 text-center'>
              <div className='text-gray-900 text-sm font-semibold'>{`Anda akan diarahkan ke aplikasi ${popup?.type === "call" ? "Telepon" : popup?.type === "tracking" ? "Browser" : "WhatsApp"}`}</div>
              <div className='text-gray-900 text-xs pt-2'>Apakah Anda yakin ingin melanjutkan?</div>
            </div>
            <div className='flex justify-between mt-2 gap-4'>
              <button 
                className='w-full bg-white text-[var(--rose-violet)] border-[var(--rose-violet)] font-semibold text-sm p-3 items-center border' 
                onClick={() => {
                  setPopup({
                    show: false,
                    confirm: false,
                    type: null,
                    value: null,
                  });
                }}
                id='merchant_change_cart_cancel'>
                Batal
              </button>
              <button 
                onClick={() => {
                  setPopup((prev) => {
                    return {
                      ...prev,
                      show: false,
                      confirm: true,
                    }
                  });
                }}
                className='w-full bg-[var(--rose-violet)] text-white font-semibold text-sm p-3 items-center border-0' id='merchant_change_cart_confirm'>
                Ya, Lanjutkan
              </button>
            </div>
          </div>
        </Modal>
      )}
		</div>
	);
}

export default Tracking;
